module.exports = __webpack_public_path__ + "static/media/menu-settings-selected.055d553b.svg";